export default __webpack_public_path__ + "static/media/JPMCFilledBackground.0fdbe174.png";